const _setAttributes = (element, map) => {
  for (let [key, value] of map) {
    element.setAttribute(key, value);
  }
}

/* Look for any elements with the class "custom-select": */
const customSelects = document.getElementsByClassName("custom-select");
for (let customSelect of customSelects) {
  const selectElement = customSelect.getElementsByTagName("select")[0];
  
  /* For each customSelect, create a new DIV that will act as the selected item: */
  const selectedDiv = document.createElement("DIV");
  const selectedDivAttrs = new Map([
    ["aria-controls", "listbox1"],
    ["aria-describedby", "listbox"],
    ["aria-expanded", "false"],
    ["aria-haspopup", "listbox"],
    ["aria-labelledby", "inquiry"],
    ["aria-required", "true"],
    ["class", "combo-input select-selected"],
    ["id", "combo1"],
    ["role", "combobox"],
    ["tabindex", "0"],
  ]);
  _setAttributes(selectedDiv, selectedDivAttrs);
  selectedDiv.innerHTML = selectElement.options[selectElement.selectedIndex].innerHTML;
  customSelect.appendChild(selectedDiv);

  /* For each customSelect, create a new DIV that will contain the option list: */
  const optionListContainer = document.createElement("DIV");
  const optionListContainerAttrs = new Map([
    ["aria-labelledby", "inquiry"],
    ["class", "combo-menu select-items select-hide"],
    ["id", "listbox1"],
    ["role", "listbox"],
    ["tabindex", "-1"],
  ])
  _setAttributes(optionListContainer, optionListContainerAttrs);
  for (j = 1; j < selectElement.length; j++) {
    _createOptionItem(selectElement, j, optionListContainer);
  }
  customSelect.appendChild(optionListContainer);
  _addToggleSelect(selectedDiv);
  _addCloseOnEscape(selectedDiv);
};

document.getElementById("contact_name").addEventListener("keyup", function(e) {
  if (e.key === 'Tab') {
    _closeAllSelect();
  }
})

function _createOptionItem(selectElement, i, optionListContainer) {
  const optionDiv = document.createElement("DIV");
  const optionDivAttrs = new Map([
    ["aria-selected", "false"],
    ["class", "combo-option"],
    ["id", `combo1-${i}`],
    ["role", "option"],
    ["tabindex", "0"],
  ]);
  optionDiv.innerHTML = selectElement.options[i].innerHTML;
  _setAttributes(optionDiv, optionDivAttrs);
  optionDiv.addEventListener("click", function(e) {
    _handleClick(this);
  });
  optionDiv.addEventListener("keyup", function(e) {
    if (e.key === 'Enter') _handleClick(e.target);
  });
  _addCloseOnEscape(optionDiv);
  optionListContainer.appendChild(optionDiv);
};

function _handleClick(target) {
  const selectElement = target.parentNode.parentNode.getElementsByTagName("select")[0];
  const selectedDiv = target.parentNode.previousSibling;
  
  for (let i in selectElement) {
    if (selectElement.options[i].innerHTML === target.innerHTML) {
      _updateSelected(selectElement, selectedDiv, i, target);
      break;
    }
  }
  selectedDiv.click();
  selectedDiv.focus();
};

function _updateSelected(selectElement, selectedDiv, i, nextSelected) {
  selectElement.selectedIndex = i;
  selectedDiv.innerHTML = nextSelected.innerHTML;
  selectedDiv.setAttribute("aria-activedescendant", nextSelected.id);
  const prevSelecteds = nextSelected.parentNode.getElementsByClassName("same-as-selected");
  for (let prevSelected of prevSelecteds) {
    prevSelected.classList.remove("option-current","same-as-selected");
    prevSelected.setAttribute("aria-selected", "false");
  }
  nextSelected.classList.add("option-current","same-as-selected");
  nextSelected.setAttribute("aria-selected", "true");
};

function _addToggleSelect(selectedDiv) {
  selectedDiv.addEventListener("click", e => _toggleSelect(e));
  selectedDiv.addEventListener("keyup", e => {
    if (e.key === "Enter") _toggleSelect(e);
  });
};

function _toggleSelect(e) {
  e.stopPropagation();
  e.target.nextSibling.classList.toggle("select-hide");
  e.target.classList.toggle("select-arrow-active");

  const isAriaExpanded = e.target.getAttribute("aria-expanded") === "true";
  e.target.setAttribute("aria-expanded", !isAriaExpanded);

  if (isAriaExpanded) e.target.setAttribute("aria-activedescendant", "");
};

function _addCloseOnEscape(selectedDiv) {
  selectedDiv.addEventListener("keyup", e => {
    if (e.key === "Escape") {
      _closeAllSelect(e);

      const parent = e.target.parentElement;
      if (parent.classList.contains('select-items')) {
        parent.previousElementSibling.focus();
      }
    };
  });
};

function _closeAllSelect(selectedDiv) {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  const list = [];
  const items = document.getElementsByClassName("select-items");
  const selecteds = document.getElementsByClassName("select-selected");

  for (let i = 0; i < selecteds.length; i++) {
    if (selectedDiv === selecteds[i]) {
      list.push(i)
    } else {
      selecteds[i].setAttribute("aria-expanded", false);
      selecteds[i].classList.remove("select-arrow-active");
    }
  }

  for (let i = 0; i < items.length; i++) {
    if (list.indexOf(i)) {
      items[i].classList.add("select-hide");
    }
  }
};

/* If the user clicks anywhere outside the select box,
then close all select boxes: */
document.addEventListener("click", _closeAllSelect);
